"use client"
import {
  BottomSheet,
  BottomSheetBody,
  BottomSheetHeader,
  BottomSheetHeaderTitle,
  FlexColumn,
  Input,
  Media,
  TextLabel,
} from "@opensea/ui-kit"
import { useRef, useState } from "react"
import { useFormContext, useWatch } from "react-hook-form"
import { useTranslations } from "use-intl"
import { Button } from "../../../../../components/Button"
import { MINIMUM_LISTING_PRICE } from "../../../constants"
import type { ListingFlowFormValues } from "../../types"

type Props = {
  listingSymbol: string
}

export const SetPriceInput = ({ listingSymbol }: Props) => {
  const t = useTranslations("wallet.SetPriceInput")
  const { control, setValue } = useFormContext<ListingFlowFormValues>()
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef<HTMLInputElement>(null!)
  const listings = useWatch({ control, name: "listings" })

  if (listings.length === 1) {
    return null
  }

  const input = (
    <Input
      className="font-mono md:w-[120px]"
      endEnhancer={listingSymbol}
      inputRef={ref}
      onChange={e => {
        const price = Number(e.target.value)
        if (!Number.isNaN(price)) {
          listings.forEach((_, index) => {
            setValue(`listings.${index}.price`, price, {
              shouldValidate: true,
            })
          })
        }
      }}
      placeholder="0.0"
      size="sm"
      step={MINIMUM_LISTING_PRICE}
      type="number"
    />
  )

  return (
    <>
      <Media lessThan="md">
        <BottomSheet
          content={
            <>
              <BottomSheetHeader>
                <BottomSheetHeaderTitle>{t("custom")}</BottomSheetHeaderTitle>
              </BottomSheetHeader>
              <BottomSheetBody>
                <FlexColumn className="gap-3">
                  <TextLabel color="text-secondary" size="2xs">
                    {t("setAllPricesTo")}
                  </TextLabel>
                  {input}
                </FlexColumn>
              </BottomSheetBody>
            </>
          }
          nested
          onOpenChange={setIsOpen}
          open={isOpen}
        >
          <Button onClick={() => setIsOpen(true)} size="sm" variant="secondary">
            {t("custom")}
          </Button>
        </BottomSheet>
      </Media>

      <Media greaterThanOrEqual="md">{input}</Media>
    </>
  )
}
